/**
 * Tenant Service
 *
 * Provides tenant configuration and payment model information
 * Reads from installation-level environment variables (not per-user)
 */

/**
 * Get payment model from environment (installation-level)
 * @returns {string} Payment model ('CONTRACT' or 'SUBSCRIPTION')
 */
export const getPaymentModel = () => {
  const paymentModel = import.meta.env.VITE_PAYMENT_MODEL;

  // Validate and return
  if (paymentModel === 'CONTRACT' || paymentModel === 'SUBSCRIPTION') {
    return paymentModel;
  }

  // Default to SUBSCRIPTION for safety
  return 'SUBSCRIPTION';
};

/**
 * Check if installation uses contract-based payment (bypasses subscription checks)
 * Note: This is now installation-level, not per-user
 * @param {Object} _cognitoUser - Ignored, kept for backward compatibility
 * @returns {boolean} True if installation uses contract payment model
 */
export const isTenantContractBased = (_cognitoUser) => {
  return getPaymentModel() === 'CONTRACT';
};

export default {
  getPaymentModel,
  isTenantContractBased,
};
